import { type TransactionDetailsResponseDTO, type TransactionSummaryDTO } from '@capsicum/common';
import { usePartners } from '@capsicum/socios-core';

import { useUserTransactionHistoryByTransactionIdQuery } from '../data-access';

export const useTransactionDetails = (transaction: TransactionSummaryDTO) => {
	const { getPartnerBy } = usePartners();

	const { data, isLoading } = useUserTransactionHistoryByTransactionIdQuery(transaction.transactionId);
	const transactionDetails = data as unknown as TransactionDetailsResponseDTO;

	const partner = getPartnerBy(p => p.shortName === transactionDetails?.summary?.currencyShortCode);
	const partnerLogoUrl = partner?.images?.partnerLogo?.url;

	return {
		isLoading,
		partnerLogoUrl,
		sections: transactionDetails?.sections,
		transaction: transactionDetails?.summary
	};
};
